import React, { MutableRefObject } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

interface ITermsOfServiceContainerMobileProps {
  isTosChecked: boolean;
  isMarketingConsentChecked: boolean;
  onTosChange: (checked: boolean) => void;
  onMarketingConsentChange: (checked: boolean) => void;
}

function TermsOfServiceContainerMobile({
  isTosChecked,
  isMarketingConsentChecked,
  onTosChange,
  onMarketingConsentChange,
}: ITermsOfServiceContainerMobileProps) {
  const countryCode = useSelector((state: any) => state.company.country_code);
  return (
    <div className={`tos-container mt-4 text-center`}>
      {countryCode === "SG" ? (
        <>
          <div className="d-flex flex-column text-left gap-1">
            <div className="d-flex align-items-center mb-2">
              <input
                type="checkbox"
                checked={isTosChecked}
                onChange={(e) => onTosChange(e.target.checked)}
                className="mr-2"
              />
              <span className="tos-text-mobile">
                <FormattedMessage
                  id="registration.agree_to_tos"
                  defaultMessage="I agree to the <buttonTag>Terms of Service</buttonTag>."
                  values={{
                    buttonTag: (text: string) => (
                      <a href="/m/terms-of-service">{text}</a>
                    ),
                  }}
                />
              </span>
            </div>
            <div className="d-flex align-items-center gap-1">
              <input
                type="checkbox"
                checked={isMarketingConsentChecked}
                onChange={(e) => onMarketingConsentChange(e.target.checked)}
                className="mr-2"
              />
              <FormattedMessage
                id="registration.marketing_consent"
                defaultMessage="I agree to receive promotional content and updates."
              />
            </div>
            <p className="mandatory-fields mt-2">
              <FormattedMessage
                id="registration.mandatory_fields"
                defaultMessage="All fields marked with an asterisk (*) are mandatory."
              />
            </p>
          </div>
        </>
      ) : (
        <>
          <FormattedMessage
            id="registration.terms_of_service"
            defaultMessage="By signing-in to your account, you agree to {breakTag}our <buttonTag>Terms of Service</buttonTag>."
            values={{
              breakTag: <br />,
              buttonTag: (text: string) => (
                <a href="/m/terms-of-service">{text}</a>
              ),
            }}
          />
        </>
      )}
    </div>
  );
}

export default TermsOfServiceContainerMobile;
